import * as React from "react";

import { ContentSection } from "../Layout/ContentSection";
import { RLink } from "../DesignSystem/RLink";
import { Heading } from "../DesignSystem/formatting/Heading";
import { Paragraph } from "../DesignSystem/formatting/Paragraph";
import { Subheading } from "../DesignSystem/formatting/Subheading";

export const ExplainSupportersPage = (): JSX.Element => {
  return (
    <div>
      <ContentSection>
        <Heading>What are supporters?</Heading>

        <Subheading>Like Chips Compo? Wanna make it BETTER?!?</Subheading>
      </ContentSection>

      <ContentSection>
        <Paragraph>
          If you like Chips Compo, you can become a subscriber and get some
          super cool features.
        </Paragraph>

        <Paragraph>
          I appreciate every subscriber. Each subscription gets me closer to
          the dream of working on Chips full time.
        </Paragraph>

        <h2>How to subscribe</h2>

        <Paragraph>
          You can subscribe{" "}
          <RLink to="https://www.patreon.com/ChipsCompo">on Patreon</RLink>.
        </Paragraph>

        <Paragraph>
          Patreon is preferred, but you can also donate via paypal to
          johnfn@gmail.com. (Let me know ahead of time so I know who I should
          hook up with benefits!)
        </Paragraph>

        <h2>Cool benefits for cool subscribers</h2>

        <ul>
          <li>Gold name and role on Discord.</li>

          <li>Change your username.</li>

          <li>Choose a color for your name on the website. (Coming soon!)</li>

          <li>See visualizations of all your past scores. (Coming soon!)</li>
        </ul>
      </ContentSection>
    </div>
  );
};
